import AbstractController from '../src/services/ControllersRepository/AbstractController';
import {default as View} from '../views/orders-calendar/OrdersCalendar';

export default class OrdersCalendar extends AbstractController {
    protected controllerName = 'Orders';

    protected availableActions: string[] = ['index'];

    protected getDefaultListComponent() {
        return View;
    }
}
